import * as React from 'react';
import styled from 'styled-components';
import { List } from 'antd';
import * as _ from 'lodash';
import { colors, fontWeights } from 'theme/variables';
import { ListItem, PaddedSection } from 'common/components';
import { UpstreamWebsiteClientInstance } from '../models/organisationModels';
import { EditClientUpstream } from './EditClientUpstream';
import { UpstreamClientSecretCode } from './UpstreamClientSecretCode';
const ListWrapper = styled.div`
    width: 100%;
    background-color: ${colors.primaryWhite};

    .ant-list-header {
        background-color: ${colors.primary};
        color: ${colors.primaryWhite};
        font-weight: ${fontWeights.bold};
    }
`;
export type props = {
    upstreamClientSettings: UpstreamWebsiteClientInstance;
    organisationId: number;
    dispatch: Function;
};
export const UpstreamDetails = ({ upstreamClientSettings, organisationId, dispatch }: props) => {
    const { clientId, allowedRedirectUrls, allowedWebOrigins, id, secret } = upstreamClientSettings;
    const upstreamDetails = [
        { name: 'Client Id', value: clientId },
        { name: 'Allowed Redirect Urls', value: allowedRedirectUrls },
        { name: 'Allowed Web Origins', value: allowedWebOrigins },
    ].map(({ name, value }) => (
        <List.Item key={_.uniqueId()}>
            <b>{name}:</b> {Array.isArray(value) ? value.join(', ') : value}
        </List.Item>
    ));
    return (
        <>
            <PaddedSection grayBg bottomBorder>
                <ListWrapper>
                    <List
                        header={<ListItem text="Upstream Keycloak Client" header="true" />}
                        bordered
                        dataSource={upstreamDetails}
                        renderItem={(item: React.ReactNode) => item}
                    />
                </ListWrapper>
                <UpstreamClientSecretCode secret={secret} id={id} organisationId={organisationId} />
            </PaddedSection>
            <EditClientUpstream
                dispatch={dispatch}
                organisationId={organisationId}
                upstreamClientSettings={upstreamClientSettings}
            />
        </>
    );
};
